import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Doughnut } from 'react-chartjs-2';
import intlShape from '@/shared/utils/intlShape';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { Chart, Legend, LinearScale, Tooltip, CategoryScale, ArcElement } from 'chart.js';
import { percentageTooltipLabel } from '@/shared/utils/chartjsHelpers';

Chart.register(Legend, LinearScale, Tooltip, CategoryScale, ArcElement);

const ComplianceOverviewChart = ({ intl, data: rawData }) => {
  const [pieData, setPieData] = useState(null);

  useEffect(() => {
    const { overallOk, overallSemiOk, overallNotOk } = rawData;

    setPieData({
      labels: [2, 1, 0].map(x => intl.formatMessage(listItemMsg('compliancestatus', x))),
      datasets: [
        {
          data: [overallOk, overallSemiOk, overallNotOk],
          backgroundColor: ['#00B295', '#F0A800', '#B80016'],
          hoverBackgroundColor: ['#00a086', '#d89700', '#a60014'],
          borderColor: '#ffffff',
          hoverBorderColor: '#ffffff',
          borderWidth: 4,
        },
      ],
    });
  }, [rawData, intl]);
  const chartOptions = {
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: 'right',
        align: 'left',
      },
      tooltip: {
        enabled: true,
        mode: 'index',
        displayColors: false,
        callbacks: {
          label: percentageTooltipLabel,
        },
      },
    },
  };
  return !pieData ? null : <Doughnut data={pieData} options={chartOptions} />;
};
ComplianceOverviewChart.propTypes = {
  intl: intlShape.isRequired,
  data: PropTypes.shape({}).isRequired,
};

export default injectIntl(ComplianceOverviewChart);
